import { ClipboardCheck, Cog, ListChecks, Phone } from 'lucide-react';
import { Card, Label, LinkButton, Screen } from '../components/ui';
import { telHref } from '../lib/format';
import { navigate } from '../lib/router';
import { useActiveTrips } from '../lib/selectors';
import { useSyncState } from '../lib/sync';

/** Всичко, което не е „днешната задача". Три реда, всеки над 80 px. */
export function MoreScreen() {
  const trips = useActiveTrips();
  const dispatcherTel = telHref(trips[0]?.dispatcher?.phone ?? null);
  const { pending, blocked } = useSyncState();

  const items = [
    { to: '/check', label: 'Проверка на буса', icon: ClipboardCheck },
    {
      to: '/queue',
      label: `Чакащи за изпращане${pending + blocked > 0 ? ` (${pending + blocked})` : ''}`,
      icon: ListChecks,
    },
    { to: '/settings', label: 'Настройки', icon: Cog },
  ];

  return (
    <Screen title="Още" logo>
      <div className="space-y-3">
        {dispatcherTel ? (
          <>
            <Label>Диспечер</Label>
            <LinkButton href={dispatcherTel} tone="brand" icon={<Phone size={26} />}>
              {trips[0]?.dispatcher?.name ?? 'Обади се'}
            </LinkButton>
          </>
        ) : null}

        {items.map((item) => (
          <Card key={item.to} onClick={() => navigate(item.to)}>
            <span className="flex items-center gap-3 text-2xl font-semibold">
              <item.icon size={30} />
              {item.label}
            </span>
          </Card>
        ))}
      </div>
    </Screen>
  );
}
